import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

import {
  parsePhoneNumberFromString,
  isPossiblePhoneNumber,
  getCountries,
  CountryCode
} from 'libphonenumber-js';

export interface MatchIsValidTelOptions {
  excludedCountries?: CountryCode[];
  onlyCountries?: CountryCode[];
}

/**
 * Lightweight replacement for mui-tel-input's matchIsValidTel
 */
export function matchIsValidTel(
  text: string,
  options: MatchIsValidTelOptions = {}
): boolean {
  const {excludedCountries, onlyCountries} = options;
  const value = text?.trim();
  if (!value) return false;

  const allCountries = getCountries();

  // Filter valid country list
  let validCountries = allCountries;

  if (onlyCountries?.length) {
    validCountries = validCountries.filter(c => onlyCountries.includes(c));
  }

  if (excludedCountries?.length) {
    validCountries = validCountries.filter(c => !excludedCountries.includes(c));
  }

  // Now validate number against these countries
  try {
    for (const country of validCountries) {
      const parsed = parsePhoneNumberFromString(value, country);
      if (parsed && parsed.isValid() && value?.includes('+')) {
        return true;
      }
    }
    // fallback: check generic "possible" number
    return isPossiblePhoneNumber(value);
  } catch {
    return false;
  }
}
